import script from "./BazaarApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./BazaarApp.vue?vue&type=script&lang=ts&setup=true"

import "./css/less/bazaar.less?vue&type=style&index=0&lang=less"

const __exports__ = script;

export default __exports__